import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import type { AxiosError } from 'axios'
import type { FetchSwapSuccessResponse } from '../../types/api/response/swap'
import type { FetchSwapPayload } from '../../types/api/payload/swap'
import { axiosInstance } from '@/modules/Core/plugins/axios'

export const QUERY_KEY = 'swap'
const ENDPOINT = '/Swap/:id'

export async function fetchSwap({ id }: FetchSwapPayload) {
  const data = await axiosInstance.get<FetchSwapSuccessResponse>(
    ENDPOINT.replace(':id', id.value),
    {
      baseURL: import.meta.env.VITE_API_OFFER_BASE_URL,
    }
  )
  return data.data
}

export function useFetchSwap(
  payload: FetchSwapPayload,
  options?: UseQueryOptions<Awaited<ReturnType<typeof fetchSwap>>>
) {
  return useQuery({
    queryFn: () => fetchSwap(payload),
    queryKey: [QUERY_KEY, payload.id],
    retry: (failureCount, error) => {
      const axiosError = error as AxiosError
      if ([422, 404].includes(axiosError?.response?.status ?? 0)) {
        return false
      }

      return failureCount < 3
    },
    ...options,
  })
}
